export function logoutUser() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
}
